import { Box, Grid, Stack, Typography } from '@mui/material'
import React from 'react'
import moment from 'moment';
import { MonthlyCalendarStyles } from './style';

export const EmpBookingMonthlyCalendar = ({ dates = {}, month = {}, events = {} }) => {

    const classes = MonthlyCalendarStyles()

    return (
        <Box>
            <Grid container mt={0} className={classes.calDates}>
                {
                    dates.map(e => {
                        return (
                            <Grid item xs={1.7} className={classes.date_outline}>
                                <Stack mt={1} justifyContent={"space-between"} height="100%" pb={2}>
                                    <Box className={classes.date}><span className={moment(e).format("M") === moment(month).format("M")
                                        ? " " : classes.hidden_other_month_dates}>{moment(e).format("DD")}</span></Box>
                                    <Box sx={{ textAlign: "right" }}>
                                        <Box m={1}>
                                            {
                                                events?.map(evnt => {
                                                    return (
                                                        evnt?.event?.length < 1 &&
                                                            moment(e).format("DD") === moment(evnt.date).format("DD")
                                                            && moment(evnt.date).format("MM") === moment(e).format("MM") ?
                                                            evnt.event.map(val => {
                                                                return (
                                                                    <Grid container spacing={0} sx={{ backgroundColor: `${val.background_color}` }} className={classes.eventlabel}>
                                                                        <Grid item xs={9.7} pl={0.5}>
                                                                            <Typography className={classes.eventtxt}> {val.title} </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                )
                                                            })
                                                            : ""
                                                    )
                                                })
                                            }
                                            {

                                                <Box>
                                                    {events.filter(i => i.date === moment(e).format("YYYY-MM-DD")).map(evnt => {
                                                        console.log(evnt)
                                                        return (
                                                            evnt?.event?.length > 1 &&
                                                                moment(e).format("DD") === moment(evnt.date).format("DD")
                                                                && moment(evnt.date).format("MM") === moment(e).format("MM") ?
                                                                <div>
                                                                    <Grid container spacing={0} sx={{ backgroundColor: `${evnt?.event[0].background_color}` }} className={classes.eventlabel}>
                                                                        <Grid item xs={9.7} pl={0.5}>
                                                                            <Typography className={classes.eventtxt}> {evnt?.event[0]?.title} </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Typography className={classes.moreLabel}> +{evnt?.event?.length - 1} more </Typography>
                                                                </div>
                                                                : ""
                                                        )
                                                    })}

                                                </Box>
                                            }
                                        </Box>
                                    </Box>
                                </Stack>
                            </Grid>
                        )
                    })
                }
            </Grid>
        </Box>
    )
}